import setHexWithAlphaToSolid from "./setHexWithAlphaToSolid";
import setTextColorBasedOnBg from "./setTextColorBasedOnBg";

const setDOMWindowStyles = (root, domChatObject) => {
    const { rdChat: domChat, isRDPlusTheme } = domChatObject;
    root.documentElement.style.setProperty('--headerColor', domChat.general.headerColor);
    root.documentElement.style.setProperty('--headerFontSize', domChat.general.headerFont.size);
    root.documentElement.style.setProperty('--headerFontColor', domChat.general.headerFont.color);
    root.documentElement.style.setProperty('--headerFontItalic', domChat.general.headerFont.italic);
    root.documentElement.style.setProperty('--sendbuttonColor', domChat.general.headerColor);
    root.documentElement.style.setProperty(
        '--headerFontUnderline',
        domChat.general.headerFont.underline
    );
    root.documentElement.style.setProperty(
        '--headerFontBold',
        domChat.general.headerFont.bold ? 'bold' : 'normal'
    );
    root.documentElement.style.setProperty(
        '--messageSystemFontStyle',
        domChat.messages.systemFont.italic ? 'italic' : 'normal'
    );
    root.documentElement.style.setProperty(
        '--headerIntroFontSize',
        domChat.general.headerIntro.size
    );
    root.documentElement.style.setProperty(
        '--headerIntroFontColor',
        domChat.general.headerIntro.color
    );
    root.documentElement.style.setProperty(
        '--headerIntroFontItalic',
        domChat.general.headerIntro.italic
    );
    root.documentElement.style.setProperty(
        '--headerIntroFontUnderline',
        domChat.general.headerIntro.underline
    );
    root.documentElement.style.setProperty(
        '--headerIntroFontBold',
        domChat.general.headerIntro.bold
    );

    root.documentElement.style.setProperty(
        '--headerDisclaimerBgColor',
        domChat.general.disclaimerBgColor
    );
    root.documentElement.style.setProperty(
        '--headerDisclaimerFontSize',
        domChat.general.disclaimerFont.size
    );
    root.documentElement.style.setProperty(
        '--headerDisclaimerFontColor',
        domChat.general.disclaimerFont.color
    );
    root.documentElement.style.setProperty(
        '--headerDisclaimerFontUnderline',
        domChat.general.disclaimerFont.underline ? 'underline' : 'unset'
    );
    root.documentElement.style.setProperty(
        '--headerDisclaimerFontBold',
        domChat.general.disclaimerFont.bold ? 'bold' : 'normal'
    );
    root.documentElement.style.setProperty(
        '--headerDisclaimerFontItalic',
        domChat.general.disclaimerFont.italic ? 'italic' : 'normal'
    );

    root.documentElement.style.setProperty('--agentBgColor', domChat.messages.agentBgColor);
    root.documentElement.style.setProperty('--agentFontSize', domChat.messages.agentFont.size);
    root.documentElement.style.setProperty('--agentFontColor', domChat.messages.agentFont.color);
    root.documentElement.style.setProperty(
        '--agentFontUnderline',
        domChat.messages.agentFont.underline
    );
    root.documentElement.style.setProperty('--agentFontBold', domChat.messages.agentFont.bold);
    root.documentElement.style.setProperty('--agentFontItalic', domChat.messages.agentFont.italic);

    root.documentElement.style.setProperty('--visitorBgColor', domChat.messages.visitorBgColor);
    root.documentElement.style.setProperty(
        '--visitorFontSize',
        domChat.messages.visitorFont.italic
    );
    root.documentElement.style.setProperty(
        '--visitorFontColor',
        domChat.messages.visitorFont.color
    );
    root.documentElement.style.setProperty(
        '--visitorFontUnderline',
        domChat.messages.visitorFont.underline
    );
    root.documentElement.style.setProperty('--visitorFontBold', domChat.messages.visitorFont.bold);
    root.documentElement.style.setProperty(
        '--visitorFontItalic',
        domChat.messages.visitorFont.italic
    );

    root.documentElement.style.setProperty(
        '--messageSystemBgColor',
        domChat.messages.systemBgColor
    );
    root.documentElement.style.setProperty(
        '--messageSystemFontSize',
        domChat.messages.systemFont.size
    );
    root.documentElement.style.setProperty(
        '--messageSystemFontColor',
        domChat.messages.systemFont.color
    );
    root.documentElement.style.setProperty(
        '--messageSystemFontUnderline',
        domChat.messages.systemFont.underline
    );
    root.documentElement.style.setProperty(
        '--messageSystemFontBold',
        domChat.messages.systemFont.bold
    );
    // root.documentElement.style.setProperty(
    //     '--messageSystemFontItalic',
    //     domChat.messages.systemFont.italic
    // );
    root.documentElement.style.setProperty(
        '--messagetypingAnimation',
        domChat.messages.typingAnimation
    );
    root.documentElement.style.setProperty(
        '--typingIndicatorDots',
        domChat.messages.typingIndicatorDots
    );

    root.documentElement.style.setProperty('--qTBorder', domChat.questionType.qTBorder);
    root.documentElement.style.setProperty('--qTButton', domChat.questionType.qTButton);
    root.documentElement.style.setProperty('--qTQuestion', domChat.questionType.qTQuestion);
    // root.documentElement.style.setProperty('--qTQuestionSvgStroke', 'rgb(17, 187, 88)');

    root.documentElement.style.setProperty('--pByMarginEmoji', '10px 5px 21px 10px');
    if (domChat.poweredBy.hidePoweredBySection) {
        root.documentElement.style.setProperty('--pByInputHeight', '33px');
        root.documentElement.style.setProperty('--pByInputHeightWindowMode', '39px');
        root.documentElement.style.setProperty('--pByInputHeightTwoLine', '48px');
        root.documentElement.style.setProperty('--pByMarginSendBtn', '1px 0 0 5px');
        root.documentElement.style.setProperty('--pBybottom', '5px');
        root.documentElement.style.setProperty('--pByDisplay', 'none');
        root.documentElement.style.setProperty('--pByMarginEmoji', '10px 5px 8px 10px');
    }
    // root.documentElement.style.setProperty('--defaultBrandingColor', 'rgb(255 255 255 / 0)');

    if (domChat.branding?.brandingIsEnabled) {
        const staticDark = "#020202";
        const brandSolid = domChat.branding.brandColorCode
        root.documentElement.style.setProperty('--brandColor', domChat.branding.brandColorCode);
        root.documentElement.style.setProperty(
            '--brandingAgentBgColor',
            domChat.messages.agentBgColor
        );
        root.documentElement.style.setProperty(
            '--brandingHeaderColor',
            domChat.general.headerColor
        );

        root.documentElement.style.setProperty('--brandColorOpacity', domChat.brandColorOpacity);
        root.documentElement.style.setProperty('--brandingwhiteText', domChat.whiteText);
        if (isRDPlusTheme) {
            const visitorMsgBubble = `${domChat.branding.brandColorCode}b3`
            root.documentElement.style.setProperty('--visitorBgColor', setHexWithAlphaToSolid(visitorMsgBubble));
            root.documentElement.style.setProperty('--visitorFontColor', setTextColorBasedOnBg(domChat.branding.brandColorCode));
            root.documentElement.style.setProperty('--headerColor', setHexWithAlphaToSolid(domChat.general.headerColor));
            root.documentElement.style.setProperty('--headerFontColor', setTextColorBasedOnBg(domChat.general.headerColor));
            root.documentElement.style.setProperty('--headerIntroFontColor', setTextColorBasedOnBg(domChat.general.headerColor));

            const textColor = setTextColorBasedOnBg(brandSolid)
            root.documentElement.style.setProperty('--participantsFontColor', textColor);
            root.documentElement.style.setProperty('--headerTitleFontColor', textColor);
            root.documentElement.style.setProperty('--phoneFontColor', textColor);
            root.documentElement.style.setProperty('--powerByFontColor', textColor);
            root.documentElement.style.setProperty('--headerFontColor', textColor);
            root.documentElement.style.setProperty('--qTButtonText', textColor);
            root.documentElement.style.setProperty('--qTBorder', staticDark);
            root.documentElement.style.setProperty('--hallowBtn', staticDark);
            root.documentElement.style.setProperty('--qTButtonIcon', staticDark);
        }
        // root.documentElement.style.setProperty('--sendbuttonColor', staticDark);
    }
};
export default setDOMWindowStyles;
